@if (isInstructionIdentificationEnabled) {
<nz-form-item>
  <nz-form-label translate>payment.receiverInfo.instructionIdentification.label</nz-form-label>
  <nz-form-control>
    <nz-select
      nzSize="large"
      nzShowSearch
      l10n-placeholder
      [nzPlaceHolder]="'payment.receiverInfo.instructionIdentification.placeholder' | translate: locale.language"
      [formControl]="instructionIdentificationControl"
    >
      @for (instructionCode of instructionCodes$ | async; track instructionCode.id) {
      <nz-option [nzLabel]="instructionCode.label" [nzValue]="instructionCode.id"></nz-option>
      }
    </nz-select>
  </nz-form-control>
</nz-form-item>
}
